var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -4,
    width: 56,
    height: 56
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_1056_21049_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 17.5,
    fill: "url(#paint0_linear_1056_21049)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 17.5,
    stroke: "url(#paint1_linear_1056_21049)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9033 27.6624C31.8321 27.5766 31.7621 27.4907 31.6934 27.4078C30.7489 26.2654 30.1774 25.5759 30.1774 22.3417C30.1774 20.6674 29.7768 19.2935 28.9873 18.2631C28.4051 17.5019 27.6182 16.9244 26.5809 16.4977C26.5676 16.4903 26.5556 16.4805 26.5457 16.4689C26.1726 15.2196 25.1517 14.3828 24.0002 14.3828C22.8487 14.3828 21.8282 15.2196 21.4551 16.4676C21.4452 16.4788 21.4334 16.4882 21.4204 16.4955C18.9998 17.492 17.8234 19.4038 17.8234 22.3405C17.8234 25.5759 17.2528 26.2654 16.3075 27.4066C16.2388 27.4894 16.1688 27.5736 16.0975 27.6611C15.9134 27.8832 15.7968 28.1533 15.7614 28.4395C15.726 28.7257 15.7734 29.0161 15.8979 29.2763C16.1628 29.8344 16.7273 30.1809 17.3718 30.1809H30.6334C31.2748 30.1809 31.8355 29.8348 32.1012 29.2793C32.2263 29.0191 32.2741 28.7285 32.239 28.4419C32.2039 28.1553 32.0874 27.8848 31.9033 27.6624Z",
    fill: "#B9FF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 33.6169C24.6206 33.6164 25.2293 33.448 25.7618 33.1296C26.2942 32.8111 26.7305 32.3545 27.0244 31.8082C27.0383 31.782 27.0451 31.7527 27.0443 31.7231C27.0435 31.6935 27.035 31.6646 27.0197 31.6392C27.0044 31.6138 26.9828 31.5929 26.957 31.5783C26.9312 31.5638 26.9021 31.5561 26.8725 31.5562H21.1289C21.0992 31.556 21.07 31.5636 21.0442 31.5781C21.0183 31.5927 20.9967 31.6136 20.9813 31.639C20.966 31.6644 20.9575 31.6933 20.9566 31.723C20.9558 31.7526 20.9626 31.782 20.9765 31.8082C21.2704 32.3545 21.7066 32.811 22.239 33.1295C22.7713 33.4479 23.3799 33.6164 24.0002 33.6169Z",
    fill: "#B9FF66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1056_21049_clip_path",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 17.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1056_21049",
    x1: 48,
    y1: 0.00000346023,
    x2: -4.08204,
    y2: 43.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF99C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAF99C",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1056_21049",
    x1: 48,
    y1: 0.00000346023,
    x2: -4.08204,
    y2: 43.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9FF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1F1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.f43fa153e13870aa3a4b2e3b79a4773f.svg";
export { ForwardRef as ReactComponent };